import { Component, OnInit, Output, ViewChild, ElementRef, OnDestroy } from '@angular/core';
import { EventEmitter } from '@angular/common/src/facade/async';
import { T2CardComponent } from '../../../../trip2-theme/components/t2-card/t2-card.component';
import { BooleanCheckComponent } from '../../../A2-utils/grid-components/boolean-check/boolean-check.component';
import { GridOptions } from 'ag-grid';
import { IMyOptions } from 'mydatepicker';
import { StandingOrderService } from '../../../../services/standing-order.service';
import { PayorsService } from '../../../payors/payors.service';
import { ToastrAlertHelper } from 'app/core/helpers/toastr-alert-helper-service';
import { Subscription } from 'rxjs/Subscription';
import { SweetAlertHelper } from 'app/core/helpers/sweet-alert-helper.service';
import { T2LoadingService } from 'app/trip2-theme/components/t2-loading/t2-loading.service';
import { CustomDate } from 'app/core/helpers/format-date-helper';
import { IPayors } from 'app/core/interfaces/invoice-external.interface';
declare const XLSX: any;

@Component({
  selector: 'app-standing-order-reviewed',
  templateUrl: './standing-order-reviewed.component.html',
  styleUrls: ['./standing-order-reviewed.component.scss']
})
export class StandingOrderReviewedComponent implements OnInit, OnDestroy {

  protected date: any;
  protected gridTrips: GridOptions;

  protected countGridTrips = 0;
  protected totalItems = 0;
  readonly FIRST_PAGE = 1;
  protected page = this.FIRST_PAGE;
  protected pagesTotal = this.FIRST_PAGE;
  protected rowsPerPage = 100;
  protected rowsPerPageOptions = [100, 200, 500, 1000];
  protected isLoading = false;

  protected selectedTrip: any = null;
  public modalStatusVisible = false;
  protected isOpenAppRidersCreate: boolean;
  public modalReservationVisible = false;

  protected payorList: Array<{ id: number; value: string }> = [];
  protected payorSelectedList: Array<{ id: number; value: string }> = [];
  protected dropdownSettings = {};
  readonly TAB_UNREVIEWED = 1;
  readonly TAB_REVIEWED = 2;
  protected activeTab = this.TAB_UNREVIEWED;

  public myRDPOptions: IMyOptions = {
    dateFormat: 'mm-dd-yyyy',
    editableDateField: false,
  };

  protected dateRangeExport: any;
  private ptrDateBegin: any;
  private ptrDateEnd: any;


  @ViewChild('modalStatus') private modalStatus: T2CardComponent;
  @ViewChild('modalReservation') private modalReservation: T2CardComponent;


  @Output() loadingMask: EventEmitter < any > = new EventEmitter < any > ();
  enableClearSort = true;
  onFiltered: boolean;
  standingorderid: number;

  private subscriptions: Subscription[] = [];

  constructor(
    private _StandingOrderService: StandingOrderService,
    private _payorsService: PayorsService,
    private toastrAlertHelper: ToastrAlertHelper,
    private sweetAlertHelper: SweetAlertHelper,
    private loadingService: T2LoadingService
  ) {
    this.gridTrips = < GridOptions > {
      enableSorting: true,
      sortingOrder: ['desc', 'asc', null],
      onFilterModified: () => {
        if (this.gridTrips.api) {
          this.countGridTrips = this.gridTrips.api.getDisplayedRowCount();
        }
      },
    };
    this.configureGrid();
    this.gridTrips.onSortChanged = () => {
      this.enableClearSort = false;
    };
    this.gridTrips.onFilterChanged = (params) => {
      this.onFiltered = params.api['filterManager'].advancedFilterPresent;
      if (params && params.api) {
        this.countGridTrips = this.onFiltered
          ? params.api.getDisplayedRowCount()
          : this.totalItems;
      }
    };
    this.gridTrips.onGridReady = (params) => {
      if (params && params.api) {
        params.api.sizeColumnsToFit();
        params.api.setRowData([]);
      }
    };
  }

  ngOnInit() {
    this.settingDropDown();
    this.loadPayors();
  }

  private settingDropDown(): void {
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'id',
      textField: 'value',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 1,
      allowSearchFilter: true,
      enableCheckAll: true,
      clearSearchFilter: false
    };
  }

  private loadPayors(): void {
    this.subscriptions.push(
      this._payorsService.getPayorsAll().subscribe({
        next: (data: IPayors[]) => {
          this.payorList = (data || []).map((payor) => ({
            id: payor.payorid,
            value: payor.description
          }));
        },
        error: (error) => {
          this.sweetAlertHelper.captureException(error);
        }
      })
    );
  }

  ngOnDestroy(): void {
    if (this.subscriptions && this.subscriptions.length) {
      this.subscriptions.forEach(sub => sub.unsubscribe());
    }
  }

  /**
   * @name onDateExportSelected
   * @description
   * @param event
   */
  onDateRangeChanged(event) {
    if (event.beginEpoc !== 0 && event.endEpoc !== 0) {
      this.ptrDateBegin = event.beginDate.year + '-' + event.beginDate.month + '-' + event.beginDate.day;
      this.ptrDateEnd = event.endDate.year + '-' + event.endDate.month + '-' + event.endDate.day;
    } else {
      this.ptrDateBegin = null;
      this.ptrDateEnd = null;
    }
  }



  /**
   * return the selected trips
   * @returns {any[]}
   */
  private getSelectedTripsId() {
    const tripsid = [];
    if (this.gridTrips.api !== null) {
      this.gridTrips.api.forEachNodeAfterFilter((node) => {
        if (node.isSelected()) {
          tripsid.push(node.data.tripid);
        }
      });
    }
    return tripsid;
  }



  /**
   * this select all rows
   * @param selected
   */
  private selectAllRows(selected) {
    if (this.gridTrips.api !== undefined) {
      this.gridTrips.api.forEachNode((node) => {
        node.setSelected(selected);
      });
    }
  }


  /**
   * Columns
   */
  /**
   * @description
   */
  private configureGrid() {
    this.gridTrips.columnDefs = [
      {
        checkboxSelection: true,
        headerCheckboxSelection: true,
        width: 40
      },
      {
        headerName: 'SO Id',
        field: 'standingorderid',
        width: 70
      },
      {
        headerName: 'Rider',
        field: 'fullname',
        valueGetter: (params) => {
          if (params && params.data && params.data.trips && params.data.trips.length) {
            const [trip] = params.data.trips.filter(t => t.rider && t.rider.fullname);
            if (trip && trip.rider && trip.rider.fullname) {
              return trip.rider.fullname;
            }
          }
          return '';
        },
        width: 140
      },
      {
        headerName: 'DoB',
        field: 'dbo',
        valueGetter: (params) => {
          if (params && params.data && params.data.trips && params.data.trips.length) {
            const [trip] = params.data.trips.filter(t => t.rider && t.rider.dobformatted);
            if (trip && trip.rider && trip.rider.dobformatted) {
              return trip.rider.dobformatted;
            }
          }
          return '';
        },
        width: 80,
      },
      {
        headerName: 'Phone Number',
        field: 'phonenumber',
        valueGetter: (params) => {
          if (params && params.data && params.data.trips && params.data.trips.length) {
            const [trip] = params.data.trips.filter(t => t.rider && t.rider.phonenumber);
            if (trip && trip.rider && trip.rider.phonenumber) {
              return trip.rider.phonenumber;
            }
          }
          return '';
        },
        width: 120
      },
      {
        headerName: 'SO Date',
        field: 'addedon',
        width: 80,
        cellRenderer: function (params) {
          const dateFormated = params.value;
          const splitDate = dateFormated.split('T');
          const dateFormatted = splitDate[0].split('-');
          const dataShow = dateFormatted[1] + '-' + dateFormatted[2] + '-' + dateFormatted[0];
          return dataShow;
        }
      },
      {
        headerName: 'Start Date',
        field: 'fromdate',
        colId: 'fromdate',
        width: 80,
        cellRenderer: function (params) {
          const dateFormated = params.value;
          const splitDate = dateFormated.split('T');
          const dateFormatted = splitDate[0].split('-');
          const dataShow = dateFormatted[1] + '-' + dateFormatted[2] + '-' + dateFormatted[0];
          return dataShow;
        }
      },
      {
        headerName: 'End Date',
        field: 'todate',
        colId: 'todate',
        width: 80,
        cellRenderer: function (params) {
          const dateFormated = params.value;
          const splitDate = dateFormated.split('T');
          const dateFormatted = splitDate[0].split('-');
          const dataShow = dateFormatted[1] + '-' + dateFormatted[2] + '-' + dateFormatted[0];
          return dataShow;
        }
      },
      {
        headerName: 'Pick Up',
        field: 'pickup',
        colId: 'pickup',
        width: 130,
      },
      {
        headerName: 'Drop Off',
        field: 'dropoff',
        colId: 'dropoff',
        width: 130,
      },
      {
        headerName: 'Provider',
        field: 'provider.speedcode',
        width: 150,
      },
       {
         headerName: 'Last SO Provider',
         field: 'laststandingorder.speedcode',
         colId: 'lastso_provider',
         width: 200,
       },
      {
        headerName: 'Payor',
        field: 'payor.description',
        width: 150,
      },
      {
        headerName: 'Status',
        field: 'standingorderstatus.description',
        colId: 'status',
        width: 80,
      },
      {
        headerName: 'Reviewed',
        field: 'reviewed',
        colId: 'reviewed',
        width: 70,
        cellRendererFramework: BooleanCheckComponent
      },
      {
        headerName: 'Mo',
        field: 'monday',
        colId: 'monday',
        width: 50,
        cellRendererFramework: BooleanCheckComponent
      },
      {
        headerName: 'Tu',
        field: 'tuesday',
        colId: 'tuesday',
        width: 50,
        cellRendererFramework: BooleanCheckComponent
      },
      {
        headerName: 'We',
        field: 'wednesday',
        colId: 'wednesday',
        width: 50,
        cellRendererFramework: BooleanCheckComponent
      },
      {
        headerName: 'Th',
        field: 'thursday',
        colId: 'thursday',
        width: 50,
        cellRendererFramework: BooleanCheckComponent
      },
      {
        headerName: 'Fr',
        field: 'friday',
        colId: 'friday',
        width: 50,
        cellRendererFramework: BooleanCheckComponent
      },
      {
        headerName: 'Sa',
        field: 'saturday',
        colId: 'saturday',
        width: 50,
        cellRendererFramework: BooleanCheckComponent
      },
      {
        headerName: 'Su',
        field: 'sunday',
        colId: 'sunday',
        width: 50,
        cellRendererFramework: BooleanCheckComponent
      }
    ];
  }


  clearFilter() {
    this.gridTrips.api.setFilterModel(null);
    this.gridTrips.api.deselectAll();
    this.onFiltered = false;
    this.countGridTrips = this.totalItems;
  }

  clearSort() {
    this.gridTrips.api.setSortModel(null);
    this.enableClearSort = true;
  }

  getTrips(data: any) {

  }

  exportToExcel() {
    const selectedRows =
      this.gridTrips &&
      this.gridTrips.api &&
      this.gridTrips.api.getSelectedRows();
    if (selectedRows && selectedRows.length) {
      const gridData = selectedRows.map((row) => this.dataToExportExcel(row));
      const ws = XLSX.utils.json_to_sheet(gridData);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'StandingOrders');
      XLSX.writeFile(wb, 'StandingOrders.xlsx');
    } else {
      this.toastrAlertHelper.info('Please select at least one record');
    }
  }

  private dataToExportExcel(data: any) {
    const rider =
      data.trips && data.trips.length
        ? data.trips.find((t: { rider: any }) => t.rider)
        : null;
    const riderData = rider && rider.rider ? rider.rider : null;
    return {
      'SO Id': data.standingorderid,
      Rider: this.valueOrEmpty(riderData && riderData.fullname),
      DoB: this.valueOrEmpty(riderData && riderData.dobformatted),
      'Phone Number': this.valueOrEmpty(riderData && riderData.phonenumber),
      'SO Date': CustomDate.formatJs(data.addedon) || '',
      'Start Date': CustomDate.formatJs(data.fromdate) || '',
      'End Date': CustomDate.formatJs(data.todate) || '',
      'Pick Up': this.valueOrEmpty(data.pickup),
      'Drop Off': this.valueOrEmpty(data.dropoff),
      Provider: this.valueOrEmpty(data.provider && data.provider.speedcode),
      'Last SO Provider': this.valueOrEmpty(data.laststandingorder && data.laststandingorder.speedcode),
      Payor: this.valueOrEmpty(data.payor && data.payor.description),
      Status: this.valueOrEmpty(data.standingorderstatus && data.standingorderstatus.description),
      Reviewed: this.boolToYesNo(data.reviewed),
      Mo: this.boolToYesNo(data.monday),
      Tu: this.boolToYesNo(data.tuesday),
      We: this.boolToYesNo(data.wednesday),
      Th: this.boolToYesNo(data.thursday),
      Fr: this.boolToYesNo(data.friday),
      Sa: this.boolToYesNo(data.saturday),
      Su: this.boolToYesNo(data.sunday),
    };
  }

  private valueOrEmpty(val: any): string {
    return val || '';
  }

  private boolToYesNo(val: any): string {
    return val ? 'Yes' : 'No';
  }

  public paramsToExport_PR() {
    const params = {
      skipHeader: false,
      columnGroups: true,
      skipFooters: true,
      skipGroups: false,
      allColumns: true,
      onlySelected: true,
      fileName: 'StandingOrders'
    };
    return params;
  }

  exportToCsv() {
    this.gridTrips.api.exportDataAsCsv(this.paramsToExport_PR());
  }

  callServiceSOSNR(resetPage = false) {
    if (this.ptrDateBegin && this.ptrDateEnd) {
      if (resetPage) {
        this.page = this.FIRST_PAGE;
      }
      this.loadingService.show();
      this._StandingOrderService.searchStandingOrders({
        fromdate: this.ptrDateBegin,
        todate: this.ptrDateEnd,
        reviewed: this.isReviewedTab,
        payorids: this.getSelectedPayorIds(),
        page: this.page,
        pagesize: this.rowsPerPage
      })
        .finally(() => this.loadingService.hiden())
        .subscribe({
          next: (response) => {
            const data = response && response.data ? response.data : [];
            this.totalItems = response && response.totalitems ? response.totalitems : 0;
            this.pagesTotal = response && response.totalpages ? response.totalpages : this.FIRST_PAGE;
            if (this.gridTrips && this.gridTrips.api) {
              this.gridTrips.api.setRowData(data);
              this.countGridTrips = this.onFiltered
                ? this.gridTrips.api.getDisplayedRowCount()
                : this.totalItems;
            }
          },
          error: (error) => {
            this.sweetAlertHelper.captureException(error);
          }
        });
    }
  }

  nexPage(paginationSum: boolean) {
    this.page = paginationSum
      ? Math.min(this.page + 1, this.pagesTotal)
      : this.pagesTotal;
    this.callServiceSOSNR();
    this.enableClearSort = true;
  }

  previusPage(paginationRest: boolean) {
    this.page = !paginationRest
      ? Math.max(this.page - 1, this.FIRST_PAGE)
      : this.FIRST_PAGE;
    this.callServiceSOSNR();
    this.enableClearSort = true;
  }

  onRowPerPage() {
    this.page = this.FIRST_PAGE;
    this.callServiceSOSNR();
    this.enableClearSort = true;
  }

  get rowSelected(): number {
    return this.gridTrips && this.gridTrips.api
      ? this.gridTrips.api.getSelectedNodes().length
      : 0;
  }

  get itemsForpage(): number {
    return this.gridTrips && this.gridTrips.api
      ? this.gridTrips.api.getDisplayedRowCount()
      : 0;
  }

  onTabChange(tab: number) {
    if (this.activeTab === tab) {
      return;
    }
    this.activeTab = tab;
    this.enableClearSort = true;
    this.clearFilter();
    if (this.ptrDateBegin && this.ptrDateEnd) {
      this.callServiceSOSNR(true);
    } else if (this.gridTrips && this.gridTrips.api) {
      this.gridTrips.api.setRowData([]);
      this.countGridTrips = 0;
      this.totalItems = 0;
      this.pagesTotal = this.FIRST_PAGE;
      this.page = this.FIRST_PAGE;
    }
  }

  onSearch() {
    this.callServiceSOSNR(true);
  }

  get isUnreviewedTab(): boolean {
    return this.activeTab === this.TAB_UNREVIEWED;
  }

  get isReviewedTab(): boolean {
    return this.activeTab === this.TAB_REVIEWED;
  }

  get isFirstPage(): boolean {
    return this.page === this.FIRST_PAGE;
  }

  get isLastPage(): boolean {
    return this.page === this.pagesTotal;
  }

  get previousPageTitle(): string {
    return this.page > this.FIRST_PAGE ? 'To the page: ' + (this.page - 1) : '';
  }

  get nextPageTitle(): string {
    return this.page < this.pagesTotal ? 'To the page: ' + (this.page + 1) : '';
  }

  get isSearchDisabled(): boolean {
    return !this.ptrDateBegin || !this.ptrDateEnd;
  }

  get isExportDisabled(): boolean {
    return this.rowSelected === 0;
  }

  get isMarkReviewedDisabled(): boolean {
    return this.rowSelected === 0;
  }

  get markReviewedButtonLabel(): string {
    return this.isReviewedTab ? 'Mark as Unreviewed' : 'Mark as Reviewed';
  }

  private getSelectedStandingOrderIds(): number[] {
    const standingOrderIds = [];
    if (this.gridTrips && this.gridTrips.api) {
      this.gridTrips.api.forEachNodeAfterFilter((node) => {
        if (node.isSelected() && node.data && node.data.standingorderid) {
          standingOrderIds.push(node.data.standingorderid);
        }
      });
    }
    return standingOrderIds;
  }

  onMarkReviewed() {
    const standingOrderIds = this.getSelectedStandingOrderIds();
    if (!standingOrderIds.length) {
      this.toastrAlertHelper.info('Please select at least one record');
      return;
    }

    const reviewed = this.isUnreviewedTab;
    const confirmText = reviewed
      ? 'Are you sure you want to mark the selected standing order(s) as reviewed?'
      : 'Are you sure you want to mark the selected standing order(s) as unreviewed?';

    this.sweetAlertHelper
      .createCustomAlert({
        title: this.markReviewedButtonLabel,
        text: confirmText,
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes'
      })
      .then((result) => {
        if (result && result.value) {
          this.updateReviewedStatus(standingOrderIds, reviewed);
        }
      });
  }

  private updateReviewedStatus(standingOrderIds: number[], reviewed: boolean) {
    this.loadingService.show();
    this.subscriptions.push(
      this._StandingOrderService.updateReviewed({
        standingorderids: standingOrderIds,
        reviewed: reviewed
      })
        .finally(() => this.loadingService.hiden())
        .subscribe({
          next: (response) => {
            const message = response && response.message
              ? response.message
              : 'Standing orders updated';
            this.toastrAlertHelper.success(message);
            this.callServiceSOSNR();
          },
          error: (error) => {
            this.sweetAlertHelper.captureException(error);
          }
        })
    );
  }

  get displayedTotalItems(): number {
    return this.totalItems ? this.totalItems : 0;
  }

  private getSelectedPayorIds(): number[] {
    if (!this.payorSelectedList || !this.payorSelectedList.length) {
      return [];
    }
    if (this.payorList && this.payorList.length
        && this.payorSelectedList.length === this.payorList.length) {
      return [];
    }
    return this.payorSelectedList.map((payor) => payor.id);
  }

  onRowDoubleClicked(event) {
    this.standingorderid = event.data.standingorderid;
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/standing-order/components/standing-order-reviewed/standing-order-reviewed.component.ts